import { RepairRequestListInfoType } from '@/types/bodyAndPaint';

interface RepairRequestConfirmFieldProps {
  info: RepairRequestListInfoType;
}
export const RepairRequestConfirmField = ({
  info,
}: RepairRequestConfirmFieldProps) => {
  // 修理依頼 依頼申請注意カード
  const RepairItemSelectNote = () => {
    const noteLabel = 'ご注意事項';
    const noteText = [
      '修理依頼後のキャンセルならびにご依頼内容の変更は、お受けすることができません',
    ];
    return (
      <div className={'request-note'}>
        <div className={'note-header'}>
          <div className={'header-icon'}>
            <i className={'icon-image'} />
          </div>
          <div className={'header-label'}>
            <span>{noteLabel}</span>
          </div>
        </div>
        <div className={'note-body'}>
          {noteText.map((text, idx) => (
            <span key={idx}>{text}</span>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className={'repair-service-request-content'}>
      <div className={'request-label'}>
        <span>{'修理依頼内容の確認'}</span>
      </div>
      <div className={'request-list'}>
        <div className={'list-content'}>
          {info.map((confirm, idx) => (
            <div className={'request-confirm-item'} key={idx}>
              <div className={'confirm-label'}>{confirm.label}</div>
              <div className={'confirm-item'}>{confirm.item}</div>
            </div>
          ))}
        </div>
      </div>
      <RepairItemSelectNote />
    </div>
  );
};
